import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a9b2e8d86bf0300143245f7_1788886004866_cf6085cb/amandajones/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a9b2e8d86bf0300143245f7_1788886004866_cf6085cb/amandajones/src/components/Navigation.tsx");
